import { Color } from './Enums';

export const colorLookup = {
  [Color.anthracite]: 'Anthracite',
  [Color.ardoise]: 'Ardoise',
  [Color.armor]: 'Armor',
  [Color.britishRacingGreen]: 'British Racing Green',
  [Color.burgundyRed]: 'Burgundy Red',
  [Color.canardBlue]: 'Canard Blue',
  [Color.chantilly]: 'Chantilly',
  [Color.chocolat]: 'Chocolat',
  [Color.coralBlue]: 'Coral Blue',
  [Color.delftBlue]: 'Delft Blue',
  [Color.englishCreme]: 'English Creme',
  [Color.faience]: 'Faience',
  [Color.frangipane]: 'Frangipane',
  [Color.frenchBlue]: 'French Blue',
  [Color.griotte]: 'Griotte',
  [Color.ivory]: 'Ivory',
  [Color.mandarine]: 'Mandarine',
  [Color.marronGlace]: 'Marron Glace',
  [Color.matteBlack]: 'Matte Black',
  [Color.olive]: 'Olive',
  [Color.plum]: 'Plum',
  [Color.portugueseBlue]: 'Portuguese Blue',
  [Color.provenceYellow]: 'Provence Yellow',
  [Color.roseQuartz]: 'Rose Quartz',
  [Color.shinyBlack]: 'Shiny Black',
  [Color.stainlessSteel]: 'Stainless Steel',
  [Color.terracotta]: 'Terracotta',
  [Color.tilleul]: 'Tilleul',
  [Color.vertSilice]: 'Vert Silice',
  [Color.vertSologne]: 'Vert Sologne',
  [Color.white]: 'White',
};
